import { Info } from "lucide-react";

export const PRICING_DISCLAIMER =
  "Prices and financing examples are provided for educational purposes only. Actual costs, rates, and terms vary by equipment, location, lender, and market conditions. Juan The Trailer Guy does not sell trailers or arrange financing.";

/** Shown on articles that mention market price ranges or sample payments. */
const PricingDisclaimer = ({ className = "" }: { className?: string }) => (
  <aside
    role="note"
    className={`flex items-start gap-3 rounded-[14px] border border-border bg-secondary p-4 text-sm leading-relaxed text-muted-foreground ${className}`}
  >
    <Info className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
    <p className="m-0">{PRICING_DISCLAIMER}</p>
  </aside>
);

export default PricingDisclaimer;
